jQuery( document ).ready(function($) {
    if (!$('body').hasClass('wp-admin')) {
        var modalContent = $('.ct_team.default .modalTemplate');
        CheckOpenModalDialog($(".ct_team.default div:not(.deeplink) > a"), 'ct_team', modalContent)
        CheckDeepLink($('.ct_team.default'), 'ct_team', modalContent);

        $('.ct_team.default .mobile-load-c2a a').click(function(e) {
            e.preventDefault();
            $(this).hide('fast', function() {
                $(this).remove();
            });


            var mediumBreakpoint = parseInt(getComputedStyle(document.body).getPropertyValue('--uk-breakpoint-m')) <= $(window).width();
            if (mediumBreakpoint) {
                var itemShow = setInterval(showItemsTablet, 300);
            }
            else {
                var itemShow = setInterval(showItemsMobile, 300);
            }

            function showItemsMobile() {
                if ($('.ct_team.default div.mobile-load').length > 0) {
                    $('.ct_team.default div.mobile-load').first()
                        .addClass('mobile-loaded')
                        .removeClass('mobile-load');
                } else {
                    clearInterval(itemShow);
                }
            }

            function showItemsTablet() {
                if ($('.ct_team.default div.tablet-load').length > 0) {
                    $('.ct_team.default div.tablet-load').first()
                        .addClass('tablet-loaded')
                        .removeClass('tablet-load');
                }
                else {
                    clearInterval(itemShow);
                }
            }
        });
    }
});